export default __webpack_public_path__ + "static/media/resume.2c869c96.pdf";